import React from 'react';
import { IApiShiajoModel } from '../../util/ApiModel/ApiShiajoModel';

export function ShiaijoLabel(props:{shiaijo:IApiShiajoModel} ){
    return <>{`${props.shiaijo.shortname} (${props.shiaijo.id})`}</>;
}